import { useState } from "react";

import { Container } from "../../components/atoms/Container";
import { ContactForm } from "../../components/organisms/Form";
import { Layout } from "../../layout/Layout";
// import { RecruiterForm } from 'Molecules/RecruiterForm';

const RecruitersPage = () => {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  return (
    <Layout
      title="Recruiter Information about Krutik Parikh"
      description="Thank you for your interest in me for software engineering roles you are hiring for."
    >
      <Container>
        <h1 className="headline text-3xl md:text-5xl lg:text-6xl mt-8">
          Hi, I&apos;m Krutik!
        </h1>
        <h2 className="headline text-xl md:text-2xl lg:text-3xl">
          Nice to meet you.
        </h2>
        <p className="mt-4 mb-4 text-lg leading-7">
          Thank you for your interest in me for the software engineering roles
          you are hiring for. I have created this page to save time for both of
          us and tell you exactly what I am looking for in my next position.
        </p>
        <h3 className="headline text-2xl mt-8">
          Which roles are of interest to me?
        </h3>
        <ul className="list-disc ml-4 mt-4">
          <li className="mt-1">Full-stack Developer</li>
          <li className="mt-1">Software Developer</li>
          <li className="mt-1">Mobile App Developer</li>
        </ul>
        <h3 className="headline text-2xl mt-8">My preferred tech stack</h3>
        <ul className="list-disc ml-4 mt-4">
          <li className="mt-1">Javascript / Typescript</li>
          <li className="mt-1">React.js / Next.js</li>
          <li className="mt-1">React-Native / Expo</li>
          <li className="mt-1">Go / Node.js</li>
          <li className="mt-1">Tailwind </li>
          <li className="mt-1">MySQL / MongoDB </li>
        </ul>
        <h3 className="headline text-2xl mt-8">
          What compensation and benefits am I looking for in my next role?
        </h3>
        <ul className="list-disc ml-4 mt-4">
          <li className="mt-1">
            <span className="font-semibold">Salary: </span>≥$180,000 p.a.
          </li>
          <li className="mt-1">
            <span className="font-semibold">Fully Remote / Hybrid </span>
          </li>
          <li className="mt-1">Annual bonus and/or equity scheme</li>
          <li className="mt-1">Flexible work schedules </li>
          <li className="mt-1">Full Health Benefits </li>
          <li className="mt-1">21 days of P.T.O</li>
          <li className="mt-1">RRSP 5% matched</li>
        </ul>
        <p className="mt-4 mb-4 text-lg leading-7">
          Currently, I am not looking for new opportunities. However, you can
          leave your contact details below and I will reach out to you when I am
          ready to take on a new position.
        </p>

        <ContactForm />
      </Container>
    </Layout>
  );
};

export default RecruitersPage;
